module.exports = __webpack_public_path__ + "static/fonts/Poppins-Italic.c103423.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-Italic.ttf
// module id = 1026
// module chunks = 11